"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _theme = require("@zip/theme");

var _react = require("@emotion/react");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SvgCoins = function SvgCoins(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  var theme = (0, _react.useTheme)();

  switch (theme.name) {
    case _theme.fearlessBusiness.name:
      return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
        viewBox: "0 0 60 60",
        fill: "none"
      }, props), {}, {
        children: [title ? (0, _jsxRuntime.jsx)("title", {
          children: title
        }) : null, (0, _jsxRuntime.jsx)("path", {
          d: "M60 30c0 16.569-13.431 30-30 30C13.431 60 0 46.569 0 30 0 13.431 13.431 0 30 0c16.569 0 30 13.431 30 30z",
          fill: "#D0EEFD"
        }), (0, _jsxRuntime.jsx)("path", {
          d: "M11 38.4a2.4 2.4 0 012.4-2.4h14.1a1.5 1.5 0 011.5 1.5v3a1.5 1.5 0 01-1.5 1.5H13.4a2.4 2.4 0 01-2.4-2.4v-1.2z",
          fill: "#6EC8FF"
        }), (0, _jsxRuntime.jsx)("path", {
          d: "M11 37.5a1.5 1.5 0 011.5-1.5h.9v6h-.9a1.5 1.5 0 01-1.5-1.5v-3zM19.4 36h7.2v6h-7.2v-6z",
          fill: "#86D1FF"
        }), (0, _jsxRuntime.jsx)("rect", {
          opacity: 0.6,
          x: 13,
          y: 30,
          width: 18,
          height: 6,
          rx: 1.5,
          fill: "#86D1FF"
        }), (0, _jsxRuntime.jsx)("path", {
          fill: "#86D1FF",
          d: "M15.4 30H25v6h-9.6zM28.6 30h.9a1.5 1.5 0 011.5 1.5v3a1.5 1.5 0 01-1.5 1.5h-.9v-6z"
        }), (0, _jsxRuntime.jsx)("rect", {
          opacity: 0.75,
          x: 13,
          y: 24,
          width: 18,
          height: 6,
          rx: 1.5,
          fill: "#86D1FF"
        }), (0, _jsxRuntime.jsx)("path", {
          fill: "#6EC8FF",
          d: "M15.4 24h8.4v6h-8.4zM28.6 24h.9a1.5 1.5 0 011.5 1.5v3a1.5 1.5 0 01-1.5 1.5h-.9v-6z"
        }), (0, _jsxRuntime.jsx)("rect", {
          x: 33,
          y: 36,
          width: 18,
          height: 6,
          rx: 1.5,
          fill: "#C9B3FF"
        }), (0, _jsxRuntime.jsx)("path", {
          fill: "#6EC8FF",
          d: "M35.4 36h8.4v6h-8.4zM48.6 36h.9a1.5 1.5 0 011.5 1.5v3a1.5 1.5 0 01-1.5 1.5h-.9v-6z"
        }), (0, _jsxRuntime.jsx)("circle", {
          cx: 41,
          cy: 28,
          r: 8,
          fill: "#6EC8FF"
        }), (0, _jsxRuntime.jsx)("circle", {
          cx: 41,
          cy: 28,
          r: 6.769,
          fill: "#86D1FF"
        }), (0, _jsxRuntime.jsx)("path", {
          d: "M41.225 33.29a.32.32 0 01-.225-.054.293.293 0 01-.113-.202l-.117-.832c-.604.013-1.132-.063-1.583-.226-.444-.171-.797-.409-1.057-.711a2.177 2.177 0 01-.482-1.011.244.244 0 01.046-.189.286.286 0 01.18-.098l1.581-.222a.49.49 0 01.244.014.84.84 0 01.214.14c.307.401.789.556 1.446.463.428-.06.748-.17.96-.328.219-.168.312-.367.28-.597a.5.5 0 00-.247-.377c-.135-.095-.338-.163-.61-.205a9.943 9.943 0 00-1.17-.127c-.985-.055-1.743-.244-2.273-.565-.53-.322-.845-.843-.946-1.564a2.198 2.198 0 01.46-1.724c.396-.517.986-.886 1.771-1.11l-.117-.832a.293.293 0 01.053-.225.32.32 0 01.202-.113l1.034-.146a.293.293 0 01.226.053.293.293 0 01.113.203l.12.855a3.723 3.723 0 011.427.32c.413.185.742.422.984.71.25.28.403.566.46.857a.286.286 0 01-.045.2.244.244 0 01-.168.097l-1.664.233a.444.444 0 01-.434-.157c-.07-.16-.217-.28-.438-.362a1.398 1.398 0 00-.75-.077c-.333.047-.582.143-.748.287a.59.59 0 00-.2.562c.033.23.177.395.434.496.255.093.713.162 1.374.207.764.03 1.382.117 1.854.26.472.136.833.352 1.085.648.25.287.41.677.48 1.168.097.697-.08 1.308-.531 1.832-.444.523-1.09.9-1.937 1.133l.117.831a.293.293 0 01-.053.226.293.293 0 01-.203.113l-1.034.145z",
          fill: "#6EC8FF"
        }), (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M51.67 18.455l1.65-6.341 6.02-1.33-6.02-2.062-1.65-5.608-1.546 5.608L44 10.784l6.124 1.33 1.546 6.34z",
          fill: "#86D1FF"
        }), (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M46.545 29.227l.978-4.325 3.568-.788-3.568-1.222L46.545 19l-.916 3.892L42 24.114l3.629.788.916 4.325z",
          fill: "#fff"
        })]
      }));

    default:
      return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
        viewBox: "0 0 60 60",
        fill: "none"
      }, props), {}, {
        children: [title ? (0, _jsxRuntime.jsx)("title", {
          children: title
        }) : null, (0, _jsxRuntime.jsx)("path", {
          d: "M60 30c0 16.569-13.431 30-30 30C13.431 60 0 46.569 0 30 0 13.431 13.431 0 30 0c16.569 0 30 13.431 30 30z",
          fill: "#EDE6FF"
        }), (0, _jsxRuntime.jsx)("path", {
          d: "M11 38.4a2.4 2.4 0 012.4-2.4h14.1a1.5 1.5 0 011.5 1.5v3a1.5 1.5 0 01-1.5 1.5H13.4a2.4 2.4 0 01-2.4-2.4v-1.2z",
          fill: "#AA8FFF"
        }), (0, _jsxRuntime.jsx)("path", {
          d: "M11 37.5a1.5 1.5 0 011.5-1.5h.9v6h-.9a1.5 1.5 0 01-1.5-1.5v-3zM19.4 36h7.2v6h-7.2v-6z",
          fill: "#C9B3FF"
        }), (0, _jsxRuntime.jsx)("rect", {
          opacity: 0.6,
          x: 13,
          y: 30,
          width: 18,
          height: 6,
          rx: 1.5,
          fill: "#C9B3FF"
        }), (0, _jsxRuntime.jsx)("path", {
          fill: "#C9B3FF",
          d: "M15.4 30H25v6h-9.6zM28.6 30h.9a1.5 1.5 0 011.5 1.5v3a1.5 1.5 0 01-1.5 1.5h-.9v-6z"
        }), (0, _jsxRuntime.jsx)("rect", {
          opacity: 0.75,
          x: 13,
          y: 24,
          width: 18,
          height: 6,
          rx: 1.5,
          fill: "#C9B3FF"
        }), (0, _jsxRuntime.jsx)("path", {
          fill: "#AA8FFF",
          d: "M15.4 24h8.4v6h-8.4zM28.6 24h.9a1.5 1.5 0 011.5 1.5v3a1.5 1.5 0 01-1.5 1.5h-.9v-6z"
        }), (0, _jsxRuntime.jsx)("rect", {
          x: 33,
          y: 36,
          width: 18,
          height: 6,
          rx: 1.5,
          fill: "#C9B3FF"
        }), (0, _jsxRuntime.jsx)("path", {
          fill: "#AA8FFF",
          d: "M35.4 36h8.4v6h-8.4zM48.6 36h.9a1.5 1.5 0 011.5 1.5v3a1.5 1.5 0 01-1.5 1.5h-.9v-6z"
        }), (0, _jsxRuntime.jsx)("circle", {
          cx: 41,
          cy: 28,
          r: 8,
          fill: "#AA8FFF"
        }), (0, _jsxRuntime.jsx)("circle", {
          cx: 41,
          cy: 28,
          r: 6.769,
          fill: "#C9B3FF"
        }), (0, _jsxRuntime.jsx)("path", {
          d: "M41.225 33.29a.32.32 0 01-.225-.054.293.293 0 01-.113-.202l-.117-.832c-.604.013-1.132-.063-1.583-.226-.444-.171-.797-.409-1.057-.711a2.177 2.177 0 01-.482-1.011.244.244 0 01.046-.189.286.286 0 01.18-.098l1.581-.222a.49.49 0 01.244.014.84.84 0 01.214.14c.307.401.789.556 1.446.463.428-.06.748-.17.96-.328.219-.168.312-.367.28-.597a.5.5 0 00-.247-.377c-.135-.095-.338-.163-.61-.205a9.943 9.943 0 00-1.17-.127c-.985-.055-1.743-.244-2.273-.565-.53-.322-.845-.843-.946-1.564a2.198 2.198 0 01.46-1.724c.396-.517.986-.886 1.771-1.11l-.117-.832a.293.293 0 01.053-.225.32.32 0 01.202-.113l1.034-.146a.293.293 0 01.226.053.293.293 0 01.113.203l.12.855a3.723 3.723 0 011.427.32c.413.185.742.422.984.71.25.28.403.566.46.857a.286.286 0 01-.045.2.244.244 0 01-.168.097l-1.664.233a.444.444 0 01-.434-.157c-.07-.16-.217-.28-.438-.362a1.398 1.398 0 00-.75-.077c-.333.047-.582.143-.748.287a.59.59 0 00-.2.562c.033.23.177.395.434.496.255.093.713.162 1.374.207.764.03 1.382.117 1.854.26.472.136.833.352 1.085.648.25.287.41.677.48 1.168.097.697-.08 1.308-.531 1.832-.444.523-1.09.9-1.937 1.133l.117.831a.293.293 0 01-.053.226.293.293 0 01-.203.113l-1.034.145z",
          fill: "#AA8FFF"
        }), (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M51.67 18.455l1.65-6.341 6.02-1.33-6.02-2.062-1.65-5.608-1.546 5.608L44 10.784l6.124 1.33 1.546 6.34z",
          fill: "#C9B3FF"
        }), (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M46.545 29.227l.978-4.325 3.568-.788-3.568-1.222L46.545 19l-.916 3.892L42 24.114l3.629.788.916 4.325z",
          fill: "#fff"
        })]
      }));
  }
};

var _default = SvgCoins;
exports["default"] = _default;